import { useEffect, useState } from 'react';
import { useAsyncAction } from './useAsyncAction';

export default function useAsyncMemo<T, const D extends unknown[]>(
    asyncFn: (...args: D) => Promise<T>,
    deps: D,
): [
    value: T | undefined,
    isLoading: boolean,
    error: any,
    trigger: () => Promise<void>,
    setValue: React.Dispatch<React.SetStateAction<T | undefined>>,
];
export default function useAsyncMemo<T, const D extends unknown[]>(
    asyncFn: (...args: D) => Promise<T>,
    deps: D,
    initialValue: T,
): [value: T, isLoading: boolean, error: any, trigger: () => Promise<void>, setValue: React.Dispatch<React.SetStateAction<T>>];
export default function useAsyncMemo<T, const D extends unknown[], InitialT = undefined>(
    asyncFn: (...args: D) => Promise<T>,
    deps: D,
    initialValue?: InitialT,
): [value: T | InitialT, isLoading: boolean, error: any, trigger: () => Promise<void>, setValue: React.Dispatch<React.SetStateAction<T | InitialT>>] {
    const [value, setValue] = useState<T | InitialT>(initialValue as T | InitialT);

    const [update, isLoading, error] = useAsyncAction(async (...deps: D) => {
        const result = await asyncFn(...deps);
        setValue(result);
    }, true);

    useEffect(() => {
        update(...deps);
    }, deps);

    return [value, isLoading, error, () => update(...deps), setValue];
}
